<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">Dashboard</h1>
    <!-- <p class="mb-8 leading-normal">
      Hey there! Welcome to Ping CRM, a demo app designed to help illustrate how
      <a
        class="text-indigo-500 hover:text-orange-600 underline"
        href="https://inertiajs.com"
      >
        Inertia.js
      </a>
      works.
    </p> -->
    <span class="py-2 px-5 text-red-500">{{ errorResult }}</span>
    <div v-if="result" class="w-full flex gap-4">
      <div class="w-full sm:max-w-3xl bg-white rounded-md shadow overflow-hidden">
        <div class="w-full py-5 text-center text-2xl font-bold">No : {{ result[0] }}</div>
        <form class="w-full" @submit.prevent="submit">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <TextArea
              v-model="form.description"
              :error="form.errors.description"
              class="pb-8 pr-6 w-full"
              label="Keterangan"
            />
            <div v-for="(item, idx) in monthLists" :key="idx" class="w-full pt-5">
              <label>Pilih Bulan : {{ idx + 1 }}</label>
              <div class="w-full flex">
                <Datepicker v-model="monthLists[idx]" monthPicker class="pt-2 w-full" />
                <button
                  v-if="idx == 0"
                  class="ml-2 rounded-full px-4 border text-green-400"
                  @click="addMonth"
                >
                  +
                </button>

                <button
                  v-else
                  class="ml-2 rounded-full px-4 border text-red-400"
                  @click="removeMonth(idx)"
                >
                  -
                </button>
              </div>
            </div>
          </div>
          <div class="flex items-center px-8 py-4 pt-8">
            <button
              class="px-5 py-2 rounded-sm border border-red-500 text-red-500"
              @click="result = null"
            >
              Cancel
            </button>
            <loading-button
              :loading="form.processing"
              class="btn-indigo ml-auto"
              type="submit"
            >
              Kirim
            </loading-button>
          </div>
        </form>
      </div>
    </div>
    <div v-else class="flex flex-wrap max-w-3xl shadow">
      <div
        v-if="errorResponse"
        class="w-full items-center justify-center px-5 text-center"
      >
        <span class="text-red-500 font-bold">Data Tidak Ditemukan! </span>
        <br />
        <br />
        <span class="font-bold text-yellow-400 pt-2">Scan Ulang Atau Masukan Code</span>
      </div>
      <div class="flex w-full items-center px-5">
        <TextInput
          v-model="form.code"
          :error="form.errors.code"
          class="w-full py-2 px-2"
          label="Code"
        />
        <button class="border px-5 py-2 mt-6" type="button" @click="getData(form.code)">
          Cari
        </button>
      </div>
      <qrcode-stream class="pt-5" @decode="onDecode" @init="onInit" />
    </div>
  </div>
</template>

<script setup>
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { QrcodeStream } from "qrcode-reader-vue3";
import { computed, ref } from "vue";
import TextInput from "@/Shared/TextInput";
import TextArea from "@/Shared/TextareaInput.vue";
import Datepicker from "vue3-date-time-picker";
import LoadingButton from "@/Shared/LoadingButton";
import axios from "axios";

let monthLists = ref([
  {
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  },
]);

const monthYear = computed(() => {
  return monthLists.value.map((item, idx) => ({
    monthyr: item.month + 1 + "-" + item.year,
  }));
});

function addMonth() {
  monthLists.value.push({
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  });
}
function removeMonth(idx) {
  monthLists.value.splice(idx, 1);
}

const errorResponse = ref(false);
const result = ref(null);
const errorResult = ref(null);
async function onDecode(res) {
  const val = res.split("-");
  await getData(val[2]);
}
async function onInit(promise) {
  try {
    await promise;
  } catch (error) {
    if (error.name === "NotAllowedError") {
      errorResult.value = "ERROR: you need to grant camera access permisson";
    } else if (error.name === "NotFoundError") {
      errorResult.value = "ERROR: no camera on this device";
    } else if (error.name === "NotSupportedError") {
      errorResult.value = "ERROR: secure context required (HTTPS, localhost)";
    } else if (error.name === "NotReadableError") {
      errorResult.value = "ERROR: is the camera already in use?";
    } else if (error.name === "OverconstrainedError") {
      errorResult.value = "ERROR: installed cameras are not suitable";
    } else if (error.name === "StreamApiNotSupportedError") {
      errorResult.value = "ERROR: Stream API is not supported in this browser";
    }
  }
}

let form = useForm({
  description: "",
  code: result.value ? result.value[2] : "",
  monthLists: monthYear.value,
});
async function getData(code) {
  await axios
    .get("/warga/" + code)
    .then(function (response) {
      // handle success
      const res = response.data.result;
      result.value = res.split("-");
      errorResponse.value = false;
      console.log(response);
    })
    .catch(function (error) {
      // handle error
      errorResponse.value = true;
      console.log(error);
    });
  console.log(result.value);
}

function submit() {}
</script>
